import SimpleButton from '../common/buttons/SimpleButton/SimpleButton';
import Avatar from '../Avatar/Avatar';
import { FiInfo } from 'react-icons/fi';
import { MdWorkspacePremium } from "react-icons/md";
function ConsultationCard({
  data,
  fillBtnTitle,
  fillBtnfun,
}) {

  // alert(JSON.stringify(data))
  function getConsultationRequestStyle() {
    const style = {
      urgent: 'bg-red-200 text-red-500',
      regular: 'bg-[#E5FEED] text-[#0EA353]',
    };
    return style[data?.priority];
  }
  function gettypeText() {
    const text = {
      inperson: 'In-Person',
      Virtual: 'Virtual',
    };
    return text[data?.consType];
  }

  return (
    <div className="consultationCard bg-white space-y-4 shadow-card_shadow p-4 rounded-xl md:px-3 flex flex-col justify-end">
      <div className="cardHead space-y-2">
        {data?.method === 'private' && data?.selecteddoctor.length == 0 && (
          <div className="flex  gap-x-1">
            <FiInfo className="text-base text-red-500" />
            <p className="text-[11px] leading-3 font-normal text-red-500 mt-0.5">
              Action required: The doctor declined the consultation.{' '}
            </p>
          </div>
        )}
        <div className="flex  items-center md:gap-2 px-2 py-3 md:p-3">
          <div className="inline-flex items-center gap-2 max-w-[60%]">
            {data?.hospitalId?.profilePic ? (
              <img
                className="size-[50px] min-w-10 bg-white rounded-full border border-white object-cover"
                src={`${process.env.REACT_APP_API_URL}/${data?.hospitalId?.profilePic}`}
                
              />
            ) : (
               <div className='h-[50px] w-[50px]'>
              <Avatar
                name={data?.hospitalId?.hospitalName}
                size="full"
                round={true}
              />
              </div>
            )}

          <div className='flex flex-col'>
             <p
              className="text-[14px] leading-7 font-bold text-coalBlack capitalize line-clamp-1 !mb-0"
              title={data?.hospitalId?.hospitalName}
            >
              {data?.hospitalId?.hospitalName}
            </p>
             {
          data?.method === 'private' &&
          <div className='privatetag'>
             Private
            </div>
            }
            </div>
           
          </div>
          <div className="px-4 py-2 inline-block bg-sky-100 text-accent baseText rounded-[5px] whitespace-nowrap capitalize user-select-none min-w-[120px] text-center ms-auto">
            {gettypeText()}
          </div>
        </div>

        <div
          className={
            'bg-[#F5FAFF] px-2 py-3 md:p-3 rounded-[5px] flex items-start justify-between min-h-14-'
          }
        >
          <p className="baseText text-navLink max-w-[75%] line-clamp-2">
            {data?.RequestDescription}
          </p>

          <div
            className={`px-4 py-2 inline-block baseText rounded-[5px] capitalize user-select-none min-w-[120px] text-center ${getConsultationRequestStyle()} whitespace-nowrap`}
          >
            {data?.priority}
          </div>
        </div>
      </div>

      <div className={'cardFooter items-center flex gap-x-4'}>
        <SimpleButton
          title={fillBtnTitle}
          buttonType={'primary'}
          customClass={'rounded-md w-full'}
          onClickEvent={fillBtnfun}
        />
      </div>
    </div>
  );
}

ConsultationCard.defaultProps = {
  fillBtnTitle: 'View',
  unFillBtnTitle: 'Delete',
  showDeleteBtn: true,
};

export default ConsultationCard;
